import { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReplaceReservationWarning from 'tenants/sealink/replace_reservation_warning';

const WarningModal = ({ product }) => {
  const modalRef = useRef();
  const [show, setShow] = useState(false);

  const closeOffcanvasRef = useRef(
    document.querySelector(
      '#experience-off-canvas [data-bs-dismiss="offcanvas"]'
    )
  );

  useEffect(() => {
    setTimeout(() => {
      if (modalRef.current?.hasSomethingToRemove()) {
        closeOffcanvasRef.current?.click();
        // Delay to ensure offcanvas is closed
        setTimeout(() => {
          setShow(true);
        }, 500);
      }
    }, 100);
  }, [product, setShow]);

  const onClose = useCallback(() => {
    setShow(false);
  }, [setShow]);

  return (
    <ReplaceReservationWarning
      ref={modalRef}
      visible={show}
      scene="experience"
      onClose={onClose}
      onRemove={() => {
        setShow(false);
      }}
      product={product}
    />
  );
};

WarningModal.propTypes = {
  product: PropTypes.shape({
    hasFerry: PropTypes.bool.isRequired,
    hasAccommodation: PropTypes.bool.isRequired,
  }),
};

export default WarningModal;
